export default function CsharpAbstraction() {
  return (
    <h2>Csharp Abstraction</h2>
  );
}
